import useVisible from "../../hooks/useVisible.jsx";
import handleClick from "../../utils/handleClick.js";
import { getCachedScript } from "../../utils/scriptCache.js";

const ALL_TRANSFORM_PROPERTIES = {
  position: {
    minValue: 100,
    maxValue: 250,
    speed: 100,
    posterizeTime: 6,
  },
  scale: {
    minValue: 0,
    maxValue: 25,
    speed: 100,
    posterizeTime: 3,
  },
  rotation: {
    minValue: -360,
    maxValue: 360,
    speed: 100,
    posterizeTime: 3,
  },
};

const POSITION_PROPERTIES = {
  position: {
    minValue: -10,
    maxValue: 10,
    speed: 100,
    posterizeTime: 6,
  },
};

const SCALE_PROPERTIES = {
  scale: {
    minValue: -10,
    maxValue: 10,
    speed: 100,
    posterizeTime: 6,
  },
};

const ROTATION_PROPERTIES = {
  rotation: {
    minValue: -3,
    maxValue: 3,
    speed: 100,
    posterizeTime: 3,
  },
};

function RandomAnimator({ selectedTag, buttonTags, generateButtonTags }) {
  const [isVisible, setIsVisible] = useVisible("RandomAnimatorGroupVisibility");
  const [animatorData, setRandomAnimatorData] = useVisible(
    "setRandomAnimatorData"
  );

  const handleRandomAnimator = (properties) => {
    handleClick("randomAnimator", properties ? { properties } : undefined);
    return false;
  };

  const handleCopy = () => {
    const code = getCachedScript();
    if (!code) {
      return false;
    }

    window.jsx.evalScript("run(saveRandomAnimatorPreset());", function (result) {
      if (result && result !== "undefined" && result !== "false") {
        setRandomAnimatorData(result);
      }
    });

    return false;
  };

  const handlePaste = () => {
    const code = getCachedScript();
    if (!code || !animatorData) {
      return false;
    }

    const presetsJson =
      typeof animatorData === "string"
        ? animatorData
        : JSON.stringify(animatorData);

    window.jsx.evalScript(
      `(function() {
        var presets = JSON.parse(${JSON.stringify(presetsJson)});
        run(randomAnimator(presets));
      })();`,
      function () {}
    );

    return false;
  };

  if (selectedTag && !buttonTags.includes(selectedTag)) {
    return null;
  }

  return (
    <>
      <li
        onClick={() => setIsVisible(!isVisible)}
        className={`button-card resolution-toggle ${isVisible ? "active" : ""}`}
      >
        <div className="button-card__icon">
          <i class="fa-regular fa-dice"></i>
          <div />
        </div>
        <div className="button-card__title">Random Animator</div>
        {generateButtonTags()}
      </li>
      <div className={`resolution-tools ${isVisible ? "" : "hidden"}`}>
        <div
          onClick={() => handleRandomAnimator()}
          className="resolution-tools__button"
        >
          <i className="fa-solid fa-arrow-pointer"></i>
          <span>Selected Properties</span>
        </div>
        <div
          onClick={() => handleRandomAnimator(ALL_TRANSFORM_PROPERTIES)}
          className="resolution-tools__button"
        >
          <i className="fa-light fa-layer-group"></i>
          <span>All Transform</span>
        </div>
        <div
          onClick={() => handleRandomAnimator(POSITION_PROPERTIES)}
          className="resolution-tools__button"
        >
          <i className="fa-light fa-arrows-up-down-left-right"></i>
          <span>Position</span>
        </div>
        <div
          onClick={() => handleRandomAnimator(SCALE_PROPERTIES)}
          className="resolution-tools__button"
        >
          <i className="fa-sharp fa-light fa-arrows-maximize"></i>
          <span>Scale</span>
        </div>
        <div
          onClick={() => handleRandomAnimator(ROTATION_PROPERTIES)}
          className="resolution-tools__button"
        >
          <i className="fa-solid fa-rotate-right"></i>
          <span>Rotation</span>
        </div>
        <div onClick={handleCopy} className="resolution-tools__button">
          <i className="fa-regular fa-copy"></i>
          <span>Copy</span>
        </div>
        <div onClick={handlePaste} className="resolution-tools__button">
          <i className="fa-light fa-paste"></i>
          <span>Paste</span>
        </div>
        <div
          onClick={() => handleClick("deleteRandomAnimator", false)}
          className="resolution-tools__button"
        >
          <i className="fa-light fa-trash"></i>
          <span>Delete</span>
        </div>
      </div>
    </>
  );
}

export default RandomAnimator;
